var _Mask;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path } from "react-native-svg";
var SvgChatIcon = function SvgChatIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _Mask || (_Mask = /*#__PURE__*/React.createElement(Mask, {
    id: "chat-icon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4 3a2 2 0 0 0-2 2v10.06c0 1.782 2.154 2.675 3.414 1.415l1.03-1.03H16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "m5.414 16.475 1.414 1.414-1.414-1.414Zm1.03-1.03v-2a2 2 0 0 0-1.414.585l1.414 1.414ZM4 5V1a4 4 0 0 0-4 4h4Zm0 8V5H0v8h4Zm0 .444V13H0v.444h4Zm0 1.616v-1.616H0v1.616h4Zm0 0H0c0 3.564 4.309 5.349 6.828 2.829L4 15.06Zm1.03-1.03L4 15.06l2.828 2.829 1.03-1.03L5.03 14.03ZM16 13.444H6.444v4H16v-4Zm0 0v4a4 4 0 0 0 4-4h-4ZM16 5v8.444h4V5h-4Zm0 0h4a4 4 0 0 0-4-4v4ZM4 5h12V1H4v4Z",
    mask: "url(#chat-icon_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M6.364 8.333h7.272c.447 0 .808-.398.808-.888 0-.491-.361-.89-.808-.89H6.364c-.447 0-.808.399-.808.89 0 .49.361.888.808.888ZM6.444 11.889H10a.889.889 0 0 0 0-1.778H6.444a.889.889 0 0 0 0 1.778Z"
  }));
};
export default SvgChatIcon;